import * as React from 'react'
import { BaseInputProps } from '@/components/inputs/base/types'
import { Textarea } from '@/components/ui/textarea'
import { cn } from '@/lib/utils'
import { InputWrapper } from '../base/input-wrapper'

export type LongTextInputProps = React.TextareaHTMLAttributes<HTMLTextAreaElement> & BaseInputProps

export const LongTextInput = React.forwardRef<HTMLTextAreaElement, LongTextInputProps>(
  (
    {
      className,
      disabled,
      placeholder,
      wrapperClassName,
      errorText,
      helperText,
      label,
      required,
      showDirtyIndicator,
      tooltip,
      isBorderless,
      ...props
    },
    ref,
  ) => {
    return (
      <InputWrapper
        wrapperClassName={wrapperClassName}
        errorText={errorText}
        helperText={helperText}
        label={label}
        required={required}
        showDirtyIndicator={showDirtyIndicator}
        tooltip={tooltip}
      >
        <Textarea
          ref={ref}
          disabled={disabled}
          className={cn(className)}
          placeholder={placeholder}
          isBorderless={isBorderless}
          {...props}
        />
      </InputWrapper>
    )
  },
)

LongTextInput.displayName = 'LongTextInput'
